import { render } from "./IntegrationList.vue?vue&type=template&id=20502cac&scoped=true"
import script from "./IntegrationList.vue?vue&type=script&lang=js"
export * from "./IntegrationList.vue?vue&type=script&lang=js"

import "./IntegrationList.vue?vue&type=style&index=0&id=20502cac&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20502cac"]])

export default __exports__